const g_replace = (str, what, wth) => {
    const regex = new RegExp(what, "g");
    return str.replace(regex, wth);
};

const cyr2lat = str => {
    let cyr = "абвгдежзийклмнопрстуфхцчшщъьюяыэёАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЬЮЯЫЭЁ";
    let lat_bg = "a,b,v,g,d,e,zh,z,i,y,k,l,m,n,o,p,r,s,t,u,f,h,ts,ch,sh,sht,a,y,yu,ya,ay,e,yo";
    let tmp = lat_bg + "," + lat_bg.toUpperCase();
    lat_bg = tmp.split(",");
    let prev = " ";
    let next = " ";
    let strLen = str.length;
    if (strLen < 1) return "";
    let retTxt = "";
    for (let i = 0; i < strLen; i++) {
        let letter = str.charAt(i);
        let num = cyr.indexOf(letter);
        if (num === -1) {
            retTxt += letter;
            continue;
        }
        if (i) prev = str.charAt(i - 1);
        if (i < strLen - 1) next = str.charAt(i + 1);
        if (num >= 33 && lat_bg[num].length > 1) {
            if (cyr.indexOf(prev) >= 33 || cyr.indexOf(next) >= 33) {
                retTxt += lat_bg[num];
            } else {
                retTxt += lat_bg[num].charAt(0) + lat_bg[num - 33].substring(1);
            }
        } else {
            retTxt += lat_bg[num];
        }
    }
    return retTxt;
};

export const textToLink = text => cyr2lat(g_replace(text.trim(), " ", "-")).toLowerCase();
